/**
 * @generated SignedSource<<d867d92e832c94f3a2fa10dce2947245>>
 * @relayHash 57b4e7806fde9d1db3802597380c18f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5ff841291f638ff0e2897bda032be5ebf24440e57d567980924a53257e5ac588

var node = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hubAri"
    },
    v2 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hubEditMode"
    },
    v3 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "operationType"
    },
    v4 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageAri"
    },
    v5 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v6 = {
      "kind": "Variable",
      "name": "operationType",
      "variableName": "operationType"
    },
    v7 = [{
      "kind": "Variable",
      "name": "ari",
      "variableName": "hubAri"
    }, v6 /*: any*/],
    v8 = {
      "kind": "ScalarField",
      "name": "asapIssuer"
    },
    v9 = {
      "kind": "ScalarField",
      "name": "mediaCollectionName"
    },
    v10 = {
      "kind": "ScalarField",
      "name": "mediaToken"
    },
    v11 = {
      "kind": "ScalarField",
      "name": "mediaUrl"
    },
    v12 = [{
      "kind": "Variable",
      "name": "ari",
      "variableName": "pageAri"
    }, v6 /*: any*/],
    v13 = [{
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "hubAri"
    }],
    v14 = {
      "kind": "InlineFragment",
      "selections": [{
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [{
          "concreteType": "HelpCenterLogo",
          "kind": "LinkedField",
          "name": "logo",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "fileId"
          }, {
            "kind": "ScalarField",
            "name": "url"
          }]
        }, {
          "concreteType": "HelpCenterBrandingColors",
          "kind": "LinkedField",
          "name": "colors",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "primary"
          }]
        }]
      }],
      "type": "HelpCenter"
    },
    v15 = {
      "condition": "hubEditMode",
      "kind": "Condition",
      "passingValue": true,
      "selections": [{
        "args": [{
          "items": [{
            "kind": "Variable",
            "name": "cloudIds.0",
            "variableName": "cloudId"
          }],
          "kind": "ListValue",
          "name": "cloudIds"
        }],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "name": "cloudUrl"
        }]
      }]
    },
    v16 = [v8 /*: any*/, v9 /*: any*/, v10 /*: any*/, v11 /*: any*/];
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/, v4 /*: any*/],
      "kind": "Fragment",
      "name": "hubBootstrapQuery",
      "selections": [{
        "args": v5 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "kind": "RequiredField",
          "field": {
            "args": v7 /*: any*/,
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": [{
              "kind": "RequiredField",
              "field": v8 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.hubMediaConfig.asapIssuer"
            }, {
              "kind": "RequiredField",
              "field": v9 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.hubMediaConfig.mediaCollectionName"
            }, {
              "kind": "RequiredField",
              "field": v10 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.hubMediaConfig.mediaToken"
            }, {
              "kind": "RequiredField",
              "field": v11 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.hubMediaConfig.mediaUrl"
            }]
          },
          "action": "THROW",
          "path": "helpCenter.hubMediaConfig"
        }, {
          "kind": "RequiredField",
          "field": {
            "alias": "pageMediaConfig",
            "args": v12 /*: any*/,
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": [{
              "kind": "RequiredField",
              "field": v8 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.pageMediaConfig.asapIssuer"
            }, {
              "kind": "RequiredField",
              "field": v9 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.pageMediaConfig.mediaCollectionName"
            }, {
              "kind": "RequiredField",
              "field": v10 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.pageMediaConfig.mediaToken"
            }, {
              "kind": "RequiredField",
              "field": v11 /*: any*/,
              "action": "THROW",
              "path": "helpCenter.pageMediaConfig.mediaUrl"
            }]
          },
          "action": "THROW",
          "path": "helpCenter.pageMediaConfig"
        }, {
          "args": v13 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v14 /*: any*/]
        }]
      }, v15 /*: any*/],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v4 /*: any*/, v3 /*: any*/, v2 /*: any*/],
      "kind": "Operation",
      "name": "hubBootstrapQuery",
      "selections": [{
        "args": v5 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v7 /*: any*/,
          "concreteType": "HelpCenterMediaConfig",
          "kind": "LinkedField",
          "name": "hubMediaConfig",
          "plural": false,
          "selections": v16 /*: any*/
        }, {
          "alias": "pageMediaConfig",
          "args": v12 /*: any*/,
          "concreteType": "HelpCenterMediaConfig",
          "kind": "LinkedField",
          "name": "hubMediaConfig",
          "plural": false,
          "selections": v16 /*: any*/
        }, {
          "args": v13 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "name": "__typename"
          }, v14 /*: any*/, {
            "kind": "InlineFragment",
            "selections": [{
              "kind": "ScalarField",
              "name": "id"
            }],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }, v15 /*: any*/]
    },
    "params": {
      "id": "5ff841291f638ff0e2897bda032be5ebf24440e57d567980924a53257e5ac588",
      "metadata": {},
      "name": "hubBootstrapQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "fa5857387ba9bbe851c826ab652f9e2b";
export default node;